export interface Bank {
    id: number
    bankName: string
}

export interface BankDetail {
    id: number
    bankName: string
    icon: string
    phone: string
    website: string
    prompt: string
    status: number
    createTime: number
}

export interface Merchant {
    id: number
    merchantName: string
}

export interface PayType {
    desc: string
    code: number
}

export interface PaymentType {
    desc: string
    value: number
}

export interface Channel {
    id: number
    channelName: string
}

export enum PaymentTypeScene {
    Loan = 'Loan',
    Repayment = 'Repayment'
}
